// extracted by mini-css-extract-plugin
module.exports = {"radio-label":"RadioInput_radio-label__PYWEW","radio-input":"RadioInput_radio-input__Ho36M","survey":"RadioInput_survey__sCDqu"};